var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 126,
    viewBox: "0 0 173 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5273 126C134.733 126 173 123.297 173 119.963C173 116.63 134.733 113.927 87.5273 113.927C40.3221 113.927 2.05463 116.63 2.05463 119.963C2.05463 123.297 40.3221 126 87.5273 126Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.132 108.749L160.933 114.06L155.325 114.543L156.126 108.025L160.132 108.749Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.695 35.8474C133.695 35.8474 134.229 42.3651 134.229 42.6065C134.229 42.8479 130.491 59.5043 130.491 59.5043C130.491 59.5043 125.15 68.6774 130.491 68.436C135.831 68.1946 134.229 59.7457 134.229 59.7457L139.837 45.7447L137.434 35.8474L133.695 35.8474Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.507 108.749L141.706 114.06L147.314 114.543L146.513 108.025L142.507 108.749Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.366 59.0217L135.03 60.7115C135.03 60.7115 134.229 67.9534 135.03 70.3673C135.831 72.7813 137.434 83.8856 137.434 84.6098C137.434 85.334 137.701 85.8168 137.434 86.0582C137.167 86.2995 136.366 86.2996 136.9 86.7824C137.434 87.2651 137.434 88.7135 137.434 88.7135V89.9205L140.905 107.784C140.905 107.784 138.769 109.956 140.371 109.956C141.973 109.956 147.848 109.956 147.581 107.542L147.047 107.301C147.047 107.301 146.246 91.3689 146.513 90.6447C146.78 89.9205 146.513 88.4721 146.513 88.4721C146.513 88.4721 145.979 87.7479 146.513 87.5065C147.047 87.2651 147.047 85.334 147.047 85.334L149.45 70.6087C149.45 70.6087 151.586 80.506 152.922 81.4716C154.257 82.4372 153.99 84.8512 153.99 84.8512L155.058 106.094C155.058 106.094 153.99 108.508 155.058 108.991C156.126 109.474 160.666 111.163 160.933 108.749C161.2 106.336 162.535 85.334 162.535 84.3684C162.535 83.4028 162.268 82.92 162.535 82.1958C162.802 81.4716 162.268 81.4716 162.535 81.4716C162.802 81.4716 162.001 80.7474 162.001 80.2646V68.4362C162.001 68.4362 162.268 66.0222 162.535 65.5394C162.802 65.0566 162.268 64.5738 162.535 63.8496C162.802 63.1254 162.001 60.7115 162.001 60.7115L149.984 57.8147L136.366 59.0217Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.712 113.095C145.712 113.095 147.047 111.888 145.178 111.888C143.978 111.91 142.796 112.156 141.706 112.612L140.371 116.957C140.371 116.957 134.897 120.94 141.039 120.457C147.18 119.974 146.246 120.337 146.246 120.337C146.246 120.337 148.115 119.854 148.382 119.371C148.649 118.888 147.848 111.888 147.848 111.888C147.848 111.888 147.047 113.819 145.712 113.095Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.194 113.094C157.194 113.094 155.859 111.887 157.728 111.887C158.928 111.91 160.11 112.156 161.2 112.612L162.535 116.957C162.535 116.957 168.009 120.94 161.867 120.457C155.725 119.974 155.859 120.336 155.859 120.336C155.859 120.336 153.99 119.854 153.723 119.371C153.456 118.888 155.058 111.887 155.058 111.887C155.058 111.887 155.859 113.819 157.194 113.094Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.837 16.777C143.671 16.777 146.78 13.967 146.78 10.5007C146.78 7.03437 143.671 4.22437 139.837 4.22437C136.003 4.22437 132.894 7.03437 132.894 10.5007C132.894 13.967 136.003 16.777 139.837 16.777Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.434 15.0873C137.434 15.0873 138.502 19.9152 138.502 20.6394C138.502 21.3636 143.041 23.5362 143.041 23.5362L148.115 17.7427C148.115 17.7427 144.911 13.6389 144.911 12.6733L137.434 15.0873Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.439 21.3637C141.439 21.3637 139.112 20.8037 138.406 19.8767C138.406 19.8767 131.025 26.433 131.025 27.64L136.9 37.0545C136.9 37.0545 136.9 40.4341 137.434 40.6755C137.968 40.9168 137.434 40.6755 137.434 41.641C137.434 42.6066 135.832 48.883 136.366 49.8485C136.9 50.8141 137.434 50.0899 136.9 51.5383C136.366 52.9867 135.03 60.7114 135.03 60.7114C135.03 60.7114 139.837 59.263 146.78 61.677C153.723 64.091 162.001 60.7114 162.001 60.7114C162.001 60.7114 159.865 56.3663 160.399 54.9179C160.933 53.4695 159.063 50.8141 159.063 50.8141L157.728 28.6056C157.728 28.6056 159.598 18.7083 158.262 18.2255L155.592 17.2599L147.041 16.3098C147.041 16.3098 144.911 21.1223 141.439 21.3637Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.695 25.9502L131.025 27.64C131.025 27.64 129.69 31.2609 131.025 32.9507C132.36 34.6405 132.894 37.0545 132.894 37.0545L138.235 36.5717L133.695 25.9502Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.536 3.86777L133.332 3.43192C133.332 3.43192 135.85 0.925758 139.353 1.14369L138.368 0.163005C138.368 0.163005 140.777 -0.708695 142.966 1.57953C144.117 2.7824 145.449 4.19631 146.279 5.78907H147.569L147.031 6.86054L148.915 7.93202L146.981 7.73955C147.164 8.66458 147.102 9.61572 146.798 10.5145L146.85 11.3614C146.85 11.3614 144.609 8.22631 144.609 7.79045V8.88009C144.609 8.88009 143.404 7.89942 143.404 7.24564L142.747 8.00839L142.419 6.80978L138.368 8.00839L139.025 7.02772L136.507 7.35462L137.492 6.15601C137.492 6.15601 134.646 7.57254 134.536 8.77115C134.427 9.96973 133.003 11.4952 133.003 11.4952L132.346 10.4056C132.346 10.4056 131.361 5.50222 134.536 3.86777Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.146 52.5325H30.0324V119.918H136.146V52.5325Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6091 78.2432H38.9651V120.289H65.6091V78.2432Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0706 80.7654H43.8934V86.8136H51.0706V80.7654Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6807 80.7654H53.5035V86.8136H60.6807V80.7654Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0706 89.0132H43.8934V95.2814H51.0706V89.0132Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6807 89.0132H53.5035V95.2814H60.6807V89.0132Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2208 103.628C63.1565 103.628 63.915 102.943 63.915 102.097C63.915 101.251 63.1565 100.565 62.2208 100.565C61.2852 100.565 60.5267 101.251 60.5267 102.097C60.5267 102.943 61.2852 103.628 62.2208 103.628Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.214 74.2517H74.5417V114.21H127.214V74.2517Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 65.2188H18.9435L27.4974 49.0518L29.4117 45.432L31.916 40.6983L33.8304 37.0784L36.0496 32.885H137.128L138.438 37.0784L139.57 40.6983L141.05 45.432L142.182 49.0518L147.235 65.2188Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.238 90.8198H76.3899V101.122H78.238V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.238 92.3511H76.3899V93.6041H78.238V92.3511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.238 98.3379H76.3899V99.5909H78.238V98.3379Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6285 90.8198H79.1621V101.122H83.6285V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6285 92.3511H79.1621V93.6041H83.6285V92.3511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6285 98.3379H79.1621V99.5909H83.6285V98.3379Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5547 90.8198H84.7065V101.122H86.5547V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5547 92.3511H84.7065V93.6041H86.5547V92.3511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5547 98.3379H84.7065V99.5909H86.5547V98.3379Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3269 90.8198H87.4788V101.122H89.3269V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3269 92.3511H87.4788V93.6041H89.3269V92.3511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3269 98.3379H87.4788V99.5909H89.3269V98.3379Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1078 90.856L89.3784 91.4453L93.3984 101.086L95.1277 100.497L91.1078 90.856Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7054 92.2891L89.9761 92.8784L90.465 94.0509L92.1943 93.4616L91.7054 92.2891Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0413 97.8912L92.312 98.4805L92.8009 99.653L94.5303 99.0637L94.0413 97.8912Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52 90.8198H121.053V101.122H125.52V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52 92.3511H121.053V93.6041H125.52V92.3511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52 98.3379H121.053V99.5909H125.52V98.3379Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.975 90.8198H118.127V101.122H119.975V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.975 92.3511H118.127V93.6041H119.975V92.3511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.975 98.3379H118.127V99.5909H119.975V98.3379Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.203 90.8198H115.355V101.122H117.203V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.203 92.3511H115.355V93.6041H117.203V92.3511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.203 98.3379H115.355V99.5909H117.203V98.3379Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.574 90.8563L109.554 100.497L111.283 101.086L115.303 91.4456L113.574 90.8563Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.976 92.2892L112.487 93.4617L114.217 94.051L114.706 92.8785L112.976 92.2892Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.64 97.891L110.152 99.0635L111.881 99.6528L112.37 98.4803L110.64 97.891Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.214 101.122H74.5417V102.097H127.214V101.122Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.192 90.8198H97.4895V101.122H107.192V90.8198Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.805 93.0471H99.8767V94.9963H104.805V93.0471Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 74.2517H100.416V83.1622H101.34V74.2517Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.878 84.5546C101.728 84.5546 102.418 83.9312 102.418 83.1623C102.418 82.3934 101.728 81.77 100.878 81.77C100.027 81.77 99.3377 82.3934 99.3377 83.1623C99.3377 83.9312 100.027 84.5546 100.878 84.5546Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57 40.6985H31.916L33.8303 37.0786H138.438L139.57 40.6985Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.182 49.0517H27.4973L29.4116 45.4319H141.05L142.182 49.0517Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.456 28.1226C153.456 28.1226 151.909 31.7171 152.232 35.2736C152.292 35.9104 152.529 36.5231 152.922 37.0543V37.0543L133.977 45.1848C133.977 45.1848 125.417 45.986 127.553 49.3655C129.69 52.7451 137.434 47.6757 137.434 47.6757C137.434 47.6757 157.728 45.0204 159.331 42.365C160.933 39.7096 162.001 28.6053 162.001 28.6053L153.456 28.1226Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.257 18.2256H158.262C158.262 18.2256 161.2 18.7084 162.001 23.5363C162.802 28.3643 163.603 29.5713 162.802 29.5713C162.001 29.5713 152.388 29.3299 152.388 29.0885C152.388 28.8471 154.257 18.2256 154.257 18.2256Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5463 90.3382C31.8937 90.3382 41.0926 82.0224 41.0926 71.7644C41.0926 61.5064 31.8937 53.1907 20.5463 53.1907C9.1989 53.1907 0 61.5064 0 71.7644C0 82.0224 9.1989 90.3382 20.5463 90.3382Z",
    fill: "#64B95C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.5463 87.7379C30.3051 87.7379 38.2162 80.5863 38.2162 71.7645C38.2162 62.9426 30.3051 55.791 20.5463 55.791C10.7875 55.791 2.8765 62.9426 2.8765 71.7645C2.8765 80.5863 10.7875 87.7379 20.5463 87.7379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 81.1904V78.8655C18.3996 78.8426 17.0547 78.4281 16.2702 77.8526L16.8081 76.3104C17.7404 76.942 18.8709 77.2886 20.0358 77.3001C21.6273 77.3001 22.7032 76.3564 22.7032 75.0444C22.7032 73.7783 21.829 72.9957 20.1703 72.3051C17.884 71.3844 16.4719 70.3255 16.4719 68.3229C16.4719 66.4123 17.7944 64.9621 19.8566 64.6169V62.292H21.2462V64.5248C22.2825 64.5376 23.2933 64.8171 24.1602 65.3304L23.5997 66.8497C22.7683 66.3352 21.7831 66.0622 20.7755 66.067C19.0496 66.067 18.3996 67.1259 18.3996 68.0467C18.3996 69.2436 19.2289 69.8421 21.179 70.6708C23.4876 71.6376 24.6533 72.8346 24.6533 74.8832C24.6533 76.7017 23.4205 78.4052 21.1117 78.7963V81.1904H19.6996Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 126,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.fba2b0a6e8b64608e8eeedab5de15fa0.svg";
export { ForwardRef as ReactComponent };